import { type FC } from "react";
import type {
  ContractType,
  ContractCompany,
} from "../../services/contract-types";
import { HiCheck } from "react-icons/hi";

interface ContractTypeCardProps {
  contractType: ContractType & { company_details: ContractCompany };
  onAdd: () => void;
  isSelected: boolean;
  onRemove: () => void;
}

const ContractTypeCard: FC<ContractTypeCardProps> = ({
  contractType,
  onAdd,
  isSelected,
  onRemove,
}) => {
  const { type, description, company_details } = contractType;
  const { color_code, color_code2 } = company_details;

  const handleClick = () => {
    if (isSelected) {
      onRemove();
    } else {
      onAdd();
    }
  };

  return (
    <div
      className={`relative rounded-lg p-4 shadow-sm ${
        isSelected ? "ring-2 ring-white" : ""
      }`}
      style={{
        background: `linear-gradient(135deg, ${color_code} 0%, ${color_code2} 100%)`,
      }}
    >
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <h4 className="text-lg font-semibold text-white">{type}</h4>
          <button
            onClick={handleClick}
            className={`rounded-lg px-3 py-2 text-sm font-medium shadow-sm ${
              isSelected
                ? "bg-red-100 text-red-800 hover:bg-red-200"
                : "bg-white text-gray-800 hover:bg-gray-100 hover:text-gray-900"
            }`}
          >
            {isSelected ? (
              <>
                <span className="flex items-center">
                  <HiCheck className="mr-1" /> Ausgewählt
                </span>
              </>
            ) : (
              "Hinzufügen"
            )}
          </button>
        </div>
        <div>
          <p className="text-sm font-medium text-white/90">
            {company_details.company}
          </p>
          {description && (
            <p className="mt-1 text-sm text-white/80">{description}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContractTypeCard;
